import { useEffect, useRef, useState, useCallback } from "react";
import MolGrid from "../../../components/Grid/MolGrid";
import Buttons from "../../../components/ui/button/Buttons";
import FormCreator from "../../../components/Forms/FormCreator";
import { RequirementListingData } from "./data/RequirementListingData";
import { RequirementListingConfig } from "./data/RequirementListingConfig";
import { useGetAllRequirmentListMutation, useLazyGetAllDropdownForCRUDCategoryQuery, } from "../../../app/services/Crud/crudApi";
import { setAllDropDownField } from "./Utils/dropdownUtils";
import { useNavigate } from "react-router-dom";
import { encryptAESID } from "../../../utils/Encryption";

const DEFAULT_PAGINATION = {
  pageNo: 1,
  pageSize: 20,
  totalCount: 0,
};

const CRUDRequirementList = () => {
  const molGridRef = useRef(null);
  const requirementRef = useRef(null);
  const navigate = useNavigate();
  const [formData, setFormData] = useState(RequirementListingData);
  const [dataSource, setDataSource] = useState([]);
  const [paginationRequest, setPaginationRequest] = useState(DEFAULT_PAGINATION);

  const [getDropdowns, { data: dropdownData, isLoading: dropdownLoading },] = useLazyGetAllDropdownForCRUDCategoryQuery();
  const [getRequirementList, { data: requirementData, isLoading: requirementLoading },] = useGetAllRequirmentListMutation();

  useEffect(() => {
    getDropdowns();
    fetchRequirements(DEFAULT_PAGINATION);
  }, []);

  useEffect(() => {
    if (!dropdownLoading && dropdownData) {
      setAllDropDownField(dropdownData);
    }
  }, [dropdownLoading, dropdownData]);

  useEffect(() => {
    if (!requirementLoading && requirementData) {
      setDataSource(requirementData?.itemList || []);
      setPaginationRequest((prev) => ({
        ...prev,
        totalCount: requirementData?.totalCount || 0,
      }));
    }
  }, [requirementLoading, requirementData]);

  const fetchRequirements = useCallback((request) => {
    getRequirementList(request);
  }, [getRequirementList]);

  const handleSearch = useCallback(() => {
    const formValues = requirementRef.current?.getFormData();
    if (!formValues) return;

    const request = {
      ...DEFAULT_PAGINATION,
      RequirmentName: formValues?.requirementName || null,
      ChannelId: formValues?.channel?.value || formValues?.channel || null,
      StatusId: formValues?.statusId?.value || formValues?.statusId || null,
    };

    setPaginationRequest(request);
    fetchRequirements(request);
  }, [fetchRequirements]);

  const handleClearClick = useCallback(() => {
    const clearedForm = {
      ...RequirementListingData,
      initialState: {
        requirementName: null,
        channel: null,
        statusId: null,
      },
    };
    let req = {
      pageNo: 1,
      pageSize: 20,
      totalCount: 0,
      RequirmentName: null,
      ChannelId: null,
      StatusId: null,
    };
    setPaginationRequest(DEFAULT_PAGINATION);
    setFormData(clearedForm);
    fetchRequirements(req);
  }, [fetchRequirements]);

  // const handlePageChange = useCallback(({ pageNumber, pageSize }) => {
  //   setPaginationRequest((prev) => {
  //     const updated = {
  //       ...prev,
  //       pageNo: pageNumber,
  //       pageSize,
  //     };
  //     fetchRequirements(updated);
  //     return updated;
  //   });
  // }, [fetchRequirements]);

  const handlePageChange = useCallback(
    ({ pageNumber, pageSize }) => {
      const updated = { ...paginationRequest, pageNo: pageNumber, pageSize };
      setPaginationRequest(updated);
      fetchRequirements(updated);
    },
    [paginationRequest, fetchRequirements]
  );

  const handleRouteToAdd = () => {
    navigate("/addRequirement");
  };

  const handleViewClick = (data) => {
    navigate(`/editCrudRequirement/${encryptAESID(data?.sgbpRequirementId)}`);
  }

  const actionHandler = {
    Edit: handleViewClick,
  };

  return (
    <div className="crud-requirement-list">
      <div className="corporate-member-list">
        <div className="member-list-filter row">
          <div className="row status-input col-12 pr-0">
            {dropdownData && (
              <FormCreator ref={requirementRef} {...formData} />
            )}
          </div>
          <div className="crud-filter-right-side-btn col-6">
            <div className="crud-clear-filter">
              <Buttons
                buttonText="Search"
                buttonTypeClassName="search-btn"
                onClick={handleSearch}
              />
              <Buttons
                buttonText="Clear"
                buttonTypeClassName="btn btn-secondary mb-2"
                onClick={handleClearClick}
              />
            </div>
            <Buttons
              buttonText="Add New"
              buttonTypeClassName="add-btn"
              onClick={handleRouteToAdd}
            />
          </div>
        </div>

        <div className="member-list">
         {requirementData && <MolGrid
            ref={molGridRef}
            configuration={RequirementListingConfig}
            dataSource={dataSource}
            allowPagination={true}
            pagination={paginationRequest}
            onPageChange={handlePageChange}
            onActionChange={actionHandler}
            isLoading={requirementLoading}
          />}
        </div>

      </div>
    </div>
  );
};

export default CRUDRequirementList;